export default {
    global: {
        use_btn: 'Get Started',
        start_use: 'Start Use',
        free_btn: 'Free Trial',
        open_btn: 'Buy Now',
        enter_btn: 'Workspace',
        outLog_btn: 'Log Out',
        login_btn: 'Registration/Login',
        tips: 'Tips',
        outlog_tips: 'This operation will log out of the current login account. Do you want to continue?',
        sure_btn: 'confirm',
        cancel: 'cancel',
        agreement_vip: 'ChatExcel Membership Agreement'
    },
    //header
    header_config: {
        product: {
            title: 'Product',
            content: [{
                    card_tit: 'ChatExcel',
                    card_cont: 'You can control excel  just by chatting'
                },
                {
                    card_tit: 'AI VOC',
                    card_cont: 'Use AI to mine data for conversational product/consumer/market insights'
                },
                {
                    card_tit: 'AI customer service',
                    card_cont: 'Full channel, full process coverage, to provide intelligent and personalized services'
                }
            ],

        },

        price: 'Price',
        tutorials: 'Tutorials',
        openPlatform: 'Open platform'
    },
    // footer
    footer_config: {
        information: '扫码添加客服微信，关注公众号',
        about_us: 'About us',
        introduce: 'Company introduction',
        update_dynamic: 'Update dynamic',
        update_log: 'Update log'
    },
    // 主页
    startPage: {
        top_title: {
            title: 'Manage Your Spreadsheets with',
            title_color: 'Simple Chat',
            title_and: '和',
            title_color_2: '数据分析',
            top_speak: 'ChatExcel does what you say',
            illustrate: 'Choice for 2000w+ users worldwide',
            top_gif: 'https://qiniu.yuankongai.com/20240927-202850.gif'
        },
        center_config: {
            tit1: 'ChatExcel automates the processing of tables',
            tit_color: 'in a chat manner',
            tit2: ''
        },
        tabs_data: [
            { id: '0', title: 'Batch processing to reduce duplication of work', content: 'ChatExcel can process large amounts of data quickly, batch processing and automation of data, reducing repetitive work.' },
            { id: '1', title: 'Intelligent understanding, alternative function processing', content: 'ChatExcel realizes the rapid analysis and mining of data, replaces function processing, and provides users with more intelligent data processing services.' },
            { id: '2', title: 'Multimodal recognition, data visualization', content: 'ChatExcel visualizes data and helps users understand it more intuitively with cool charts.' },
        ],
        area_data: [
            { id: '0', title: 'Section 1 Title', img_url: 'answer1' },
            { id: '1', title: 'Section 2 Title', img_url: 'answer2' },
            { id: '2', title: 'Section 3 Title', img_url: 'answer3' },
        ],
        price_config: {
            tit1: 'Our Pricing',
            tit_color: '',
            price_p1: 'Time limited',
            price_p2: '，',
            price_p3: 'Membership duration',
            price_p4: '',
            price_color1: 'Special Offer Activities',
            price_color2: 'Double the gift',
            priceList: [{
                    id: 1,
                    title: 'Free',
                    symbol: '$',
                    price: '0',
                    date: '',
                    priceold: 'Free trial for 3 days',
                },
                // {
                //     id: 2,
                //     title: 'Lifetime VIP',
                //     price: '199',
                //     priceold: 'Original price ¥999',
                //     symbol: '¥',
                //     date: '',
                // },
                {
                    id: 2,
                    title: 'Monthly VIP',
                    symbol: '$',
                    price: '9.9',
                    date: 'month',
                    priceold: 'Original price 29/month',
                },
                {
                    id: 3,
                    title: 'One year VIP',
                    symbol: '$',
                    price: '99',
                    date: 'year',
                    priceold: 'Original price 348/year',
                },
                {
                    id: 4,
                    title: 'Half a year VIP',
                    symbol: '$',
                    price: '79',
                    date: 'half a year',
                    priceold: 'Original price 174/half a year',
                }
            ],
        },
        recommend_config: {
            tit: 'They all recommend',
            tit_color: 'ChatExcel',
            commentList: [{
                    avatar: 'avatar1',
                    name: "Workplace veteran",
                    comment: "Cool Table ChatExcel is eye-catching and a godsend for professionals, saving time, effort, and worry",
                },
                {
                    avatar: 'avatar2',
                    name: "Mr. Admin Palace",
                    comment: "You developed the ChatExcel website, which is very cool. It uses natural language to describe requirements and machines to perform table operations, which is very suitable for the needs of our entire industry.",
                },
                {
                    avatar: 'avatar3',
                    name: "Manager",
                    comment: "I only have four words to say, thank you. Thank you for your hard work and dedication to our cousin who is still working hard on the front line. We look forward to your early liberation.",
                },
                {
                    avatar: 'avatar4',
                    name: "Teacher Wang",
                    comment: "Cool ChatExcel, once you enter a sentence, it will automatically run and give me the desired result. For daily work tables, the processing effect is amazing, it's really great!",
                },
                {
                    avatar: 'avatar5',
                    name: "Market Manager",
                    comment: "The value of tools is to improve efficiency and enhance user experience. ChatExcel greatly reduces the threshold for using Excel, allowing those of us who are not good at Excel to process data quickly and accurately.",
                },
                {
                    avatar: 'avatar6',
                    name: "Primary school teacher",
                    comment: "Sorting out tables of various grades allows for simple calculations and data organization without the need for functions. There are many students and exams, but teachers also have many treasures",
                },
                {
                    avatar: 'avatar7',
                    name: "Customer service",
                    comment: "For beginners, it is easy to use, and for customer service, the dialogue format is more convenient for handling forms.",
                },
                {
                    avatar: 'avatar8',
                    name: "HR specialist",
                    comment: "Not long after joining, I struggled to organize employee information in spreadsheets due to a lack of Excel skills. However, using ChatExcel does not require technical background and can efficiently integrate information.",
                },
                {
                    avatar: 'avatar9',
                    name: "Data entry personnel",
                    comment: "ChatExcel can simultaneously delete batch cell contents, which greatly reduces my workload. Get off work early!",
                },
                {
                    avatar: 'avatar10',
                    name: "college student",
                    comment: "Special forces style tourism planning and budget management can be achieved in just a few words, truly my special forces team! And the key is free, free, free! This wool is really fragrant.",
                },
                {
                    avatar: 'avatar11',
                    name: "Oral Medical Administrator",
                    comment: "I used to use command+F to search for specific patient information, click on them one by one, delete and modify them, and use chatexcel to help me complete the changes in one sentence",
                },
            ],
        },

    },
    // 选择套餐弹窗
    priceDialogPage: {
        dialog_title: 'Choose a package',
        member_type: 'Membership',
        member_type_list: [{
            name: 'ChatExcel Package'
        }],
        purchase_duration: 'Subscriptions',
        payment_order: 'payment',
        actual_payment: 'Amount',
        VIPExclusive: '现在下单 VIP用户专享100M带宽和独享算力通道',
        pay_type: 'Payment method',
        agreement: 'Payment is deemed consent',
        original_price: 'cost price',
        priceold_unit: '$',
        symbol: '$',
    },
    // 登录弹窗
    loginDialogPage: {
        type_phone_or_email: 'Email login',
        type_email: 'Email login',
        type_psd: 'Password login',
        phoneoremail: '',
        phoneoremail_placeholder: 'Email',
        code: '',
        inside_code: 'Inside code',
        code_placeholder: 'Verification code',
        send_code: 'Send code',
        repeat: 'Resend in seconds',
        account_number: '',
        psd: '',
        psd_placeholder: 'Password',
        remember: 'Remember me',
        forget_psd: 'Forget password?',
        loginOrRegister: 'Log In',
        login: 'Log In',
        register_tips: 'After email verification, it will automatically log in',
        confirmation_agreement: {
            text1: 'By proceeding, you are agreeing to ChatExcel’s',
            text2: 'and',
            agreement1: 'User agreement',
            agreement2: 'Personal Information Protection Policy'
        },
        reset: {
            back: 'Back',
            title: 'Forget Your Password?',
            tit_cont: "Enter your email in the form below and we'll send you instructions for setting a new password.",
            email_label: 'Email Address',
            email_label_placeholder: 'Email',
            btn: 'Send Email',
            sending: 'Your email is on the way',
            sent_to: 'The verification code has been sent to ',
            code_label: 'Verification code',
            next: 'Next',
            tit_reset: 'Reset password',
            newpsd: 'New password',
            configpsd: 'Confirm password'
        }
    }
}